import type { ValueFormatterParams } from "ag-grid-community";

import { Badge } from "~/ui";

export const ChipCellRenderer = (params: ValueFormatterParams<string>) => {
  const label = (params?.value as string) || "";
  return label ? (
    <Badge variant="outline" color="gray">
      {label}
    </Badge>
  ) : null;
};
